import type { FC } from 'react';

import { ComparisonTable } from '@/components/comparison-table';
import { WidgetProps } from '@/components/widget-block';

const CarInsuranceComparison: FC<WidgetProps> = ({ anchor }) => {
  return (
    <ComparisonTable
      features={[
        {
          type: 'carDamage',
          title: 'Damage to your car',
        },
        {
          type: 'propertyDamage',
          title: 'Damage to another person’s property',
        },
        {
          type: 'fireAndTheft',
          title: 'Fire & theft',
        },
        {
          type: 'liabilityCover',
          title: '$20 million liability cover',
        },
        {
          type: 'keyRemotesAndLocks',
          title: 'Your keys, remotes and locks',
        },
        {
          type: 'theftHireCar',
          title: 'Hire car after theft',
        },
        {
          type: 'personalBelongings',
          title: 'Personal belongings',
        },
        {
          type: 'carTowing',
          title: 'Towing your damaged car',
        },
        {
          type: 'babySeats',
          title: 'Baby seats & baby capsules',
        },
        {
          type: 'accidentHireCar',
          title: 'Hire car after accident',
        },
        {
          type: 'removeWindscreenExcess',
          title: 'Remove windscreen excess',
        },
      ]}
      products={[
        {
          title: 'Comprehensive',
          isFeatured: false,
          featuredLabel: 'Recommended',
          features: [
            {
              type: 'carDamage',
              isIncluded: true,
            },
            {
              type: 'propertyDamage',
              isIncluded: true,
            },
            {
              type: 'fireAndTheft',
              isIncluded: true,
            },
            {
              type: 'liabilityCover',
              isIncluded: true,
            },
            {
              type: 'keyRemotesAndLocks',
              isIncluded: true,
            },
            {
              type: 'theftHireCar',
              isIncluded: true,
            },
            {
              type: 'personalBelongings',
              isIncluded: true,
            },
            {
              type: 'carTowing',
              isIncluded: true,
            },
            {
              type: 'babySeats',
              isIncluded: true,
            },
            {
              type: 'accidentHireCar',
              isIncluded: true,
              conditions: 'Optional cover',
            },
            {
              type: 'removeWindscreenExcess',
              isIncluded: true,
              conditions: 'Optional cover',
            },
          ],
        },
        {
          title: 'Third party, fire and theft',
          isFeatured: false,
          features: [
            {
              type: 'carDamage',
              isIncluded: true,
              conditions: 'If damaged by an uninsured driver',
            },
            {
              type: 'propertyDamage',
              isIncluded: true,
            },
            {
              type: 'fireAndTheft',
              isIncluded: true,
            },
            {
              type: 'liabilityCover',
              isIncluded: true,
            },
            {
              type: 'carTowing',
              isIncluded: true,
              conditions: 'If damaged by an uninsured driver, or as a result of fire or theft',
            },
          ],
        },
        {
          title: 'Third party only',
          isFeatured: false,
          features: [
            {
              type: 'carDamage',
              isIncluded: true,
              conditions: 'If damaged by an uninsured driver',
            },
            {
              type: 'propertyDamage',
              isIncluded: true,
            },
            {
              type: 'liabilityCover',
              isIncluded: true,
            },
            {
              type: 'carTowing',
              isIncluded: true,
              conditions: 'If damaged by an uninsured driver',
            },
          ],
        },
      ]}
      headerHeight={9}
      anchor={anchor}
    />
  );
};

export { CarInsuranceComparison };
